import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import "./Feature_section.css";

const data = [
  {
    icon: "/assets/Images/Home/Home_Category_Banner/Feature_section/search.png",
    title: "Pick Your Product",
    desc: "Find the perfect item for your brand.",
  },
  {
     icon: "/assets/Images/Home/Home_Category_Banner/Feature_section/development.png",
    title: "Customize & Order",
    desc: "Upload your logo & confirm your order.",
  },
  {
     icon: "/assets/Images/Home/Home_Category_Banner/Feature_section/Tracking.png",
    title: "Track In Real Time",
    desc: "Stay updated with tracking.",
  },
  {
     icon: "/assets/Images/Home/Home_Category_Banner/Feature_section/boxes.png",
    title: "Get It & Love It",
    desc: "Receive and enjoy your product.",
  },
];

function Feature_section() {
  return (
    <div className="Feature_section">
      <Row className="g-3">
        {data.map((item, index) => (
          <div className="col-xxl-3 col-xl-4 col-md-6"  key={index}>
            <div className="Feature_section_card">

              <div className="icon_hodler">
                <img src={item.icon} className="Feature_icon" alt="icon"/>
              </div>
              <div>
                <h6>{item.title}</h6>
                <p>{item.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </Row>
    </div>
  );
}

export default Feature_section;